import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const AchievementsPage = () => (
  <Box sx={{ minHeight: '80vh', background: '#f5f7fa', py: { xs: 4, md: 8 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Container maxWidth="md">
      <Typography variant="h3" align="center" sx={{ fontWeight: 800, color: 'primary.main', mb: 4 }}>
        Achievements
      </Typography>
      <Typography variant="h5" align="center" color="text.secondary">
        Achievements section coming soon.
      </Typography>
    </Container>
  </Box>
);

export default AchievementsPage; 